import { render } from "./Univ-Details.vue?vue&type=template&id=2cf44b24&scoped=true"
import script from "./Univ-Details.vue?vue&type=script&lang=js"
export * from "./Univ-Details.vue?vue&type=script&lang=js"

import "./Univ-Details.vue?vue&type=style&index=0&id=2cf44b24&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2cf44b24"

export default script